import { PreloadingStore } from './PreloadingStore';
import { IgnorePreloadingStore } from './IgnorePreloadingStore';
import { isPreloadingActivated } from '../../js/environment-utils';

export const createPreloadingStore = (formatConfig: any) => {
  if (isPreloadingActivated(formatConfig)) {
    return new PreloadingStore();
  }
  return new IgnorePreloadingStore();
};
